import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  standalone: false,
  selector: 'dsp-qa-banner',
  templateUrl: 'qa-banner.component.html',
  styleUrls: [ 'qa-banner.component.scss' ]
})
export class QaBannerComponent {
  public env = environment;
}
